var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-list-item",
      attrs: { "data-template": "group", "data-size": "2x2" },
    },
    [
      _c("div", { staticClass: "go-card-main" }, [
        _vm.groupData.originParentDocDetail &&
        _vm.groupData.originParentDocDetail.documentList &&
        _vm.groupData.originParentDocDetail.documentList.length
          ? _c("div", { staticClass: "go-card-body" }, [
              _c("div", { staticClass: "go-card-headline" }, [
                _c(
                  "a",
                  {
                    staticClass: "go-card-title line-clamp-1",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.viewDetail(
                          _vm.groupData.originParentDocDetail.documentList[0]
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.groupData.originParentDocDetail.documentList[0]
                            .title
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "go-card-body",
                    staticStyle: {
                      width: "100%",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("div", { staticClass: "go-card-desc" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.groupData.originParentDocDetail.documentList[0]
                              .source_summary
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "go-card-img",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.viewDetail(
                              _vm.groupData.originParentDocDetail
                                .documentList[0]
                            )
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            loading: "lazy",
                            src:
                              _vm.groupData.originParentDocDetail
                                .documentList[0].image_uri_thumbnail ||
                              "content/images/sample/@516x290.png",
                            alt: "",
                          },
                          on: {
                            error: function ($event) {
                              $event.target.src =
                                "content/images/sample/@516x290.png"
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-card-list-group" }, [
                _c(
                  "ul",
                  { staticClass: "go-card-inline-list" },
                  _vm._l(
                    _vm.groupData.originParentDocDetail.documentList.slice(
                      _vm.currentPage * _vm.size,
                      _vm.currentPage * _vm.size + _vm.size
                    ),
                    function (document, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "go-list-item" },
                        [
                          index
                            ? _c("div", { staticClass: "go-item-inner" }, [
                                _c("span", { staticClass: "go-card-info" }, [
                                  _vm._v(
                                    _vm._s(_vm.getHostName(document.source_uri))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "go-card-title",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.viewDetail(document)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(document.title) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "go-block-center",
                    staticStyle: { position: "absolute", bottom: "20px" },
                  },
                  [
                    _c("div", { staticClass: "go-slide-pagination" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-slide-nav go-slide-nav-prev",
                          attrs: { type: "button", disabled: !_vm.currentPage },
                          on: { click: _vm.back },
                        },
                        [
                          _c("i", {
                            staticClass: "go-icon-20 go-icon-chevron-left",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-slide-page" }, [
                        _c("span", { staticClass: "go-slide-page-current" }, [
                          _vm._v(_vm._s(_vm.currentPage + 1)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "go-slide-page-total" }, [
                          _vm._v(
                            _vm._s(
                              Math.ceil(
                                _vm.groupData.originParentDocDetail.documentList
                                  .length / _vm.size
                              )
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn go-slide-nav go-slide-nav-next",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.currentPage + 1 ===
                              Math.ceil(
                                _vm.groupData.originParentDocDetail.documentList
                                  .length / _vm.size
                              ),
                          },
                          on: { click: _vm.next },
                        },
                        [
                          _c("i", {
                            staticClass: "go-icon-20 go-icon-chevron-right",
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }